export const scrolledMoreThan = val => {
  const b = document.body.scrollTop;
  const e = document.documentElement.scrollTop;
  const w = window.pageYOffset;
  return Math.max(b, e, w) > val;
};
